// Mise en forme des indicateurs du pilotage (conception, § 7). Les chiffres viennent de `pilot_overview`.
export type PilotWeek = {
  week: string;
  sales_id: number;
  name: string | null;
  count: number;
};

export type PilotOverview = {
  everyone: boolean;
  weeks: PilotWeek[];
  reply_rates: { kind: "email" | "linkedin"; sent: number; replied: number }[];
  without_action: number;
  overdue: { sales_id: number; name: string | null; count: number }[];
  stuck: number;
  journal_since: string | null;
  conversion: { position: number; stage: string; entered: number; reached: number }[];
  prescriptions: { quarter: string; count: number }[];
  created: { month: string; count: number }[];
};

export const replyRate = (sent: number, replied: number) =>
  sent > 0 ? Math.round((replied / sent) * 100) : null;

export const weeksTable = (weeks: PilotWeek[]) => {
  const columns = [...new Set(weeks.map((w) => w.week))].sort();
  const names = [...new Set(weeks.map((w) => w.name ?? String(w.sales_id)))].sort();
  return {
    weeks: columns,
    rows: names.map((name) => ({
      name,
      counts: columns.map(
        (week) =>
          weeks.find((w) => w.week === week && (w.name ?? String(w.sales_id)) === name)
            ?.count ?? 0,
      ),
    })),
  };
};
